import * as React from 'react';

import BaseArrow from './BaseArrow';

import ArrowBackIcon from '../icons/ArrowBackIcon';

interface Size {
  height: number;
  width: number;
}

interface Props {
  containerSize: Size;
  onPress?: () => void;
  children?: React.ReactNode;
}

const ArrowLeft: React.FunctionComponent<Props> = props => {
  const {containerSize, onPress} = props;
  return (
    <BaseArrow
      containerSize={containerSize}
      position={'left'}
      onPress={onPress}>
      <ArrowBackIcon size={14} color={'white'} />
    </BaseArrow>
  );
};

export default React.memo(ArrowLeft);
